const computeRoleData = ({ ownerId, supervisorId, isComplete, approvedBySupervisor, currentUserId }) => {

    const isOwnerAndSupervisorSame = ownerId === supervisorId;
    const isCurrentUserOwner = currentUserId === ownerId;
    const isCurrentUserSupervisor = currentUserId === supervisorId;

    const role = (isOwnerAndSupervisorSame || isCurrentUserSupervisor)
        ? 'supervisor'
        : isCurrentUserOwner
        ? 'owner'
        : null;

    const canOwnerUpdate = isCurrentUserOwner && !approvedBySupervisor;
    const canSupervisorUpdate = isCurrentUserSupervisor && isComplete  ;
    const forbiddenUpdate = !canOwnerUpdate && !canSupervisorUpdate && !(isOwnerAndSupervisorSame && isCurrentUserOwner);

    return { role, canOwnerUpdate, canSupervisorUpdate, forbiddenUpdate };
};

export const milestoneOrFocalAreaAccess = (milestoneOrFocalAreaOrList) => {
    if (Array.isArray(milestoneOrFocalAreaOrList)) {
        return milestoneOrFocalAreaOrList.map(computeRoleData);
    }
    return computeRoleData(milestoneOrFocalAreaOrList);
};

